import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
export default {
	name: 'changepassword',
	components: {
		VueElementLoading
	},
	props: [],
	data() {
		return {
			isLoading: false,
			oldpassword: '',
			newpassword: '',
			confirmpassword: '',
			localwarehouseid: '',
			localclientid: '',
			loginuserid: ''
		}
	},
	computed: {

	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.localwarehouseid = userdetail.warehouseid;
		this.localclientid = userdetail.clientid;
		this.loginuserid = userdetail.userid;
	},
	methods: {
		changePassword() {
			if (this.oldpassword == '' || this.oldpassword == null) {
				return false;
			}
			if (this.newpassword == '' || this.newpassword == null) {
				return false;
			}
			var pass = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/
			if (!this.newpassword.match(pass)) {
				this.$alertify.error("New Password Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters")
				return false;
			}
			if (this.confirmpassword == '' || this.confirmpassword == null) {
				return false;
			}
			if (this.confirmpassword != this.newpassword) {
				this.$alertify.error("New Password And Confirm Password Must Be Same")
				return false;
			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				userid: this.loginuserid,
				//	warehouseid: this.localwarehouseid,
				oldpassword: this.oldpassword,
				newpassword: this.newpassword
			})
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'changepassword',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.data.code == 0) {
						this.isLoading = false
						this.$alertify.success(response.data.data.msg);
						localStorage.removeItem('permissiondata')
						localStorage.removeItem('userdetail')
						localStorage.removeItem('userToken')
						localStorage.removeItem('isLoggedIn')
						this.$router.push('/login')
					} else if (response.data.data.code == -1) {
						this.isLoading = false
						this.$alertify.error(response.data.data.msg)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		resetForm() {
			this.oldpassword = '';
			this.newpassword = '',
				this.confirmpassword = '';
			this.$validator.reset();
			this.errors.clear();
		},
		onSubmit: function(event) {
			this.$validator
				.validateAll()
				.then((result) => {
					if (result) {
						console.log("form is valid", this.model);
						event.target.reset();
					} else {
						return false;
					}
				})
				.catch(() => {
					console.log("errors exist", this.errors);
				});
		}

	}
}


// WEBPACK FOOTER //
// ./src/views/components/changepassword/changepassword.component.js